import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import useRouter from '@/composables/useRouter'
import WidgetBaseComponent from '@/components/widgets/WidgetBaseComponent.vue'
import { Icons } from '@/icons/icons'
import { ContextName } from '@/store/types/storeGlobalTypes'
import { ActionTypes, checkActionIcon } from '@/store/modules/actions/actionsTypes'
import { URLS } from '@/router/routes/urlRoutes'
import useSelectedRegister from '@/composables/useSelectedRegister'
import useStage from '@/composables/useStage'
import useGlobalVisionWidgets, {
  ActionLastActionsWidgetData
} from '@/components/expedients/ExpedientCourts/composables/useGlobalVisionWidgets'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'
import useTruncation from '@/composables/useTruncation'

interface ActionRow {
  idType: ActionTypes
  idAction: string
  [key: string]: any
}

// TRANSALATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpedientLastActionsWidget',
  setup(__props) {

const { t } = useI18n()

// ROUTER
const router = useRouter()

// CONSTS
const emptyTableText = t('components.widgets.expedient_last_actions.empty_table_text')
const openWindowIcon = Icons.OPEN_WINDOW

const contexts = {
  lastActions: ContextName.EXPEDIENT_LAST_ACTIONS_WIDGET,
  expedientContext: ContextName.EXPEDIENTS
}

// DATA
const showSpinner = ref(true)
const widgetData = ref<ActionLastActionsWidgetData>({
  title: '',
  body: {
    headers: [],
    cells: []
  }
})

// COMPOSABLES
const { selectedRegisterId: selectedExpedientId } = useSelectedRegister({ entityName: contexts.expedientContext })
const { expedientStage } = useStage()
const { fetchExpedientLastActionsWidgetData } = useGlobalVisionWidgets()

// COMPUTED
const typedCells = computed<ActionRow[]>(() => widgetData.value.body.cells as ActionRow[])

const { isTruncatedItems, setRef, checkTruncation } = useTruncation({
  items: typedCells as ComputedRef<ActionRow[]>
})

const allDataLoaded = computed(() => !!widgetData.value.title)

const expedientStageState = computed(() => expedientStage.value)

// METHODS
const fetchLastActionsData = async () => {
  showSpinner.value = true

  widgetData.value = (await fetchExpedientLastActionsWidgetData({
    selectedExpedientId: selectedExpedientId.value,
    filter: {
      source: contexts.lastActions,
      idStage: expedientStageState.value
    }
  })) as ActionLastActionsWidgetData
  showSpinner.value = false
}

const openActionInNewWindow = async (actionType: ActionTypes, selectedActionId: string) => {
  let routeData: any = null

  switch (actionType) {
    case ActionTypes.CALLS:
      routeData = router.resolveRoute({
        name: `${URLS.ACTIONS}-${URLS.CALLS}`,
        params: { selectedRegisterId: selectedActionId }
      })
      break
    case ActionTypes.MEETINGS:
      routeData = router.resolveRoute({
        name: `${URLS.ACTIONS}-${URLS.MEETINGS}`,
        params: { selectedRegisterId: selectedActionId }
      })
      break
    case ActionTypes.PROCEDURES:
      routeData = router.resolveRoute({
        name: `${URLS.ACTIONS}-${URLS.PROCEDURES}`,
        params: { selectedRegisterId: selectedActionId }
      })
      break
    case ActionTypes.OTHERS:
      routeData = router.resolveRoute({
        name: `${URLS.ACTIONS}-${URLS.ACTION_OTHERS}`,
        params: { selectedRegisterId: selectedActionId }
      })
      break
    case ActionTypes.LEXNET:
      routeData = router.resolveRoute({
        name: `${URLS.ACTIONS}-${URLS.ACTION_LEXNET}`,
        params: { selectedRegisterId: selectedActionId }
      })
      break
    case ActionTypes.EMAILS:
      routeData = router.resolveRoute({
        name: `${URLS.ACTIONS}-${URLS.ACTION_EMAILS}`,
        params: { selectedRegisterId: selectedActionId }
      })
      break
    case ActionTypes.INTERNAL_MANAGEMENT:
      routeData = router.resolveRoute({
        name: `${URLS.ACTIONS}-${URLS.ACTION_INTERNAL_MANAGEMENT}`,
        params: { selectedRegisterId: selectedActionId }
      })
      break
    case ActionTypes.TASK:
      routeData = router.resolveRoute({
        name: `${URLS.ACTIONS}-${URLS.ACTION_TASKS}`,
        params: { selectedRegisterId: selectedActionId }
      })
      break
  }

  window.open(routeData.href, '_blank')
}

const goToActions = () => {
  router.goToRoute({
    name: URLS.ACTION_ALL
  })
}

// WATCHERS
watch(
  () => expedientStageState.value,
  () => {
    fetchLastActionsData()
  }
)

// INIT
fetchLastActionsData()

return { __sfc: true,t, router, emptyTableText, openWindowIcon, contexts, showSpinner, widgetData, selectedExpedientId, expedientStage, fetchExpedientLastActionsWidgetData, typedCells, isTruncatedItems, setRef, checkTruncation, allDataLoaded, expedientStageState, fetchLastActionsData, openActionInNewWindow, goToActions, WidgetBaseComponent, checkActionIcon, LexonTooltipComponent }
}

})